import React from "react";
import { Box, styled, Tabs, Tab, Paper, Avatar, Dialog, DialogContent, Typography } from "@mui/material";
import styles from "./settings.module.css";
import { ReactComponent as Logo } from "assets/logo.svg";
import GButton from "components/gbutton";
import { Formik } from "formik";
import FormInput from "components/forminput";
import { useAuth } from "hooks/useUser";
import config from "config";
import { Link } from "react-router-dom";

const TopTab = styled(Tab)({
  justifyContent: "flex-start",
  fontWeight: "600",
  textTransform: "capitalize",
  padding: "10px 20px",
  fontSize: 16,
});

function Settings() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <div>
      <Box
        sx={{
          position: "sticky",
          top: 84,
          zIndex: 1,
        }}>
        <Tabs
          sx={{
            backgroundColor: "#fff",
            "& .MuiTabs-indicator": {
              bgcolor: "primary.main",
              height: 4,
            },
          }}
          value={value}
          onChange={handleChange}>
          <TopTab label="Profile" />
          <TopTab label="Change Password" />
          <TopTab label="Logout" />
        </Tabs>
      </Box>
      <Paper
        sx={{
          maxWidth: "688px",
          marginX: "auto",
          mt: 3,
          px: 15,
          pt: 5,
          pb: 7,
          "@media (max-width: 600px)": {
            px: 2,
            mt: 0,
          },
        }}>
        {value === 0 && <Profile />}
        {value === 1 && <ChangePassword />}
        <Dialog open={value === 2} onClose={() => setValue(0)} fullWidth maxWidth="sm">
          <DialogContent
            sx={{
              textAlign: "center",
            }}>
            <Logo />
            <Box
              sx={{
                my: 8,
              }}>
              <Typography>Sign out?</Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-around",
                  my: 8,
                }}>
                <GButton onClick={() => setValue(0)} variant="text" color="primary" size="large">
                  No
                </GButton>
                <GButton
                  onClick={() => {
                    localStorage.removeItem(config.tokenKey);
                    window.location.href = "/";
                  }}
                  variant="text"
                  color="error"
                  size="large">
                  Yes, Sign out
                </GButton>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </Paper>
    </div>
  );
}

export default Settings;

function Profile() {
  const { data } = useAuth();
  return (
    <>
      <Avatar
        sx={{
          width: 72,
          height: 72,
          mx: "auto",
        }}
      />
      <table className={styles.table}>
        <tbody>
          <tr>
            <th>First Name</th>
            <td>{data?.firstName}</td>
          </tr>
          <tr>
            <th>Last Name</th>
            <td>{data?.lastName}</td>
          </tr>
          <tr>
            <th>Marital Status</th>
            <td>{data?.maritalStatus}</td>
          </tr>
          <tr>
            <th>Education</th>
            <td>{data?.education?.replaceAll("_", " ")}</td>
          </tr>
          <tr>
            <th>Employment Status</th>
            <td>{data?.employmentStatus}</td>
          </tr>
        </tbody>
      </table>
      {/* @ts-ignore -component is allowed */}
      <GButton fullWidth component={Link} to="/setup" variant="contained" size="large">
        Edit profile
      </GButton>
    </>
  );
}

function ChangePassword() {
  return (
    <Formik initialValues={{}} onSubmit={() => {}}>
      {({ handleSubmit }) => (
        <Box component="form" onSubmit={handleSubmit}>
          <FormInput id="password" label="Old Password" required type="password" name="password" />
          <FormInput id="new-password" label="New Password" required type="password" name="newPassword" />
          <FormInput id="confirmpassword" label="Confirm Password" required type="password" name="oldPassword" />
          <GButton variant="contained" size="large" fullWidth>
            Change Password
          </GButton>
        </Box>
      )}
    </Formik>
  );
}
